import React from "react";
import PropTypes, { instanceOf } from "prop-types";
import { withCookies, Cookies } from "react-cookie";
import { connect } from "react-redux";

import CompatStoryCard from "cards/containers/CompatStoryCard";
import StreamSpinner from "stream/components/StreamSpinner";
import { loadRevision, loadLatest } from "actions/storiesStream";
import { COOKIES } from "config/constants";

class Preview extends React.Component {
  componentDidMount() {
    const adminToken = this.props.cookies.get(COOKIES.ADMIN_TOKEN);
    if (this.props.revision) {
      return this.props.loadRevision(
        this.props.permalinkId,
        this.props.revision,
        adminToken
      );
    } else {
      return this.props.loadLatest(this.props.permalinkId, adminToken);
    }
  }

  render() {
    if (!this.props.story) return <StreamSpinner />;
    return <CompatStoryCard story={this.props.story} index={0} />;
  }
}

const mapStateToProps = state => ({
  story: state.storiesStream.results[0],
});

const mapDispatchToProps = {
  loadLatest,
  loadRevision,
};

const PreviewWithRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(Preview);

Preview.propTypes = {
  permalinkId: PropTypes.string.isRequired,
  revision: PropTypes.string,
  loadLatest: PropTypes.func.isRequired,
  loadRevision: PropTypes.func.isRequired,
  story: PropTypes.object,
  cookies: instanceOf(Cookies).isRequired,
};

export default withCookies(PreviewWithRedux);
